import {type IAsset} from '@netx/core-asset-next/schema';
import {assetHasAudio} from '@netx/core-asset-next/utils/assetHasAudio';
import {assetHasPdf} from '@netx/core-asset-next/utils/assetHasPdf';
import {assetHasVideo} from '@netx/core-asset-next/utils/assetHasVideo';

export const getPreviewTypeFromAsset = (
	asset?: Pick<
		IAsset,
		'assetId' | 'filetypelabel' | 'fileFormatFamily' | 'viewNames'
	>,
) => {
	if (!asset) return;
	if (assetHasAudio(asset.fileFormatFamily, asset.viewNames)) return 'audio';
	if (assetHasPdf(asset)) return 'document';
	if (assetHasVideo(asset.fileFormatFamily, asset.viewNames)) return 'video';
	return 'image';
};
